module.exports = __webpack_public_path__ + "img/websites.ad6581f0.svg";